import type { QueryClient } from '@tanstack/react-query';

// R2-G62 follow-up: Refine creates a fresh QueryClient per <Refine key> mount;
// AppRefine registers the live one here so authStore.logout() can clear cached
// queries without importing the provider tree (cycle-free seam).
let activeQueryClient: QueryClient | null = null;

export const registerQueryClient = (client: QueryClient): void => {
  activeQueryClient = client;
};

export const unregisterQueryClient = (client: QueryClient): void => {
  if (activeQueryClient === client) activeQueryClient = null;
};

/** Wipe cached data queries on the live client (no-op before boot).
 *  Refine's auth queries (key head 'auth': the useAuthenticated check /
 *  onError) are EXCLUDED: logout() runs from inside authProvider.check on
 *  401, and clear()ing the in-flight check query kills its observer — the
 *  <Authenticated> gate then never settles and the app hangs on the loading
 *  skeleton (the staging stuck-screen, R3-DEV1). Data freshness only needs
 *  the data queries gone. */
export const clearQueryCache = (): void => {
  if (!activeQueryClient) return;
  activeQueryClient.removeQueries({
    predicate: (query) => query.queryKey[0] !== 'auth',
  });
  activeQueryClient.getMutationCache().clear();
};
